export default function HeroBanner() {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="bg-primary dark:glass rounded-3xl p-10 md:p-14 flex flex-col md:flex-row items-center justify-between gap-8 ">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-bold">Ready to streamline your daybook?</h2>
            <p className="text-slate-700 dark:text-slate-300 mt-3">Bring order to site chaos with effortless logging and accountable records.</p>
          </div>
          <div className="flex gap-3">
            <a href="/contact" className="px-5 py-3 rounded-xl bg-sky-500 hover:bg-sky-400 text-white font-semibold shadow-smooth">Request a Demo</a>
            {/* <a href="/products/daybook" className="px-5 py-3 rounded-xl glass font-semibold">Learn More</a> */}
          </div>
        </div>
      </div>
    </section>
  )
}
